import { render, staticRenderFns } from "./TranslationsDataTable.vue?vue&type=template&id=4c571aea&"
import script from "./TranslationsDataTable.vue?vue&type=script&lang=js&"
export * from "./TranslationsDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports